/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForAssessmentDataCollection extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForAssessmentDataCollection");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForAssessmentDataCollection.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForAssessmentDataCollection>): BackgroundJobPayloadForAssessmentDataCollection {
        let obj = Object.assign(new BackgroundJobPayloadForAssessmentDataCollection(), model);
        BackgroundJobPayloadForAssessmentDataCollection.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForAssessmentDataCollection>): BackgroundJobPayloadForAssessmentDataCollection {
        if (!model) return null;
        return BackgroundJobPayloadForAssessmentDataCollection.newInstance(<BackgroundJobPayloadForAssessmentDataCollection> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForAssessmentDataCollection) {
        if (!obj) return;

        models.BackgroundJobPayloadForAssessmentDataCollection.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForAssessmentDataCollection): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForAssessmentDataCollection.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service Account ID that needs to processed
     */
    service_account_id: string;

}
